import { render, staticRenderFns } from "./WiaaHelp.vue?vue&type=template&id=04183ab1&"
import script from "./WiaaHelp.vue?vue&type=script&lang=js&"
export * from "./WiaaHelp.vue?vue&type=script&lang=js&"
import style0 from "./WiaaHelp.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports